import { Injectable } from '@angular/core';
import { HttpService } from '../../../services/http/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentoInfoService {

  constructor(private http: HttpService) { }

  buscaSaldoGlobal(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);
  }

  buscarSaldoRecebiveis(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/enterprise/returnRetailReceivablesBalance', data, successHandle, errorHandle);
  }

  taxasTermos(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/reuse/enterprise-product', data, successHandle, errorHandle);
  }
}
